import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';

import {triggerDetailPopup, WORD_HELP_POPUP_PADDING} from '../../defines/client.const';


@Component({
  selector: 'app-example-help',
  templateUrl: './example-help.component.html',
  styleUrls: ['./example-help.component.scss'],
  animations: [triggerDetailPopup],
})
export class ExampleHelpComponent implements OnInit {
  @Output() closePopup: EventEmitter<void>;

  public calculatedHeight: number = window.innerHeight - WORD_HELP_POPUP_PADDING;

  @HostListener('window:resize')
  onResize(): void {
    this.calculatedHeight = window.innerHeight - WORD_HELP_POPUP_PADDING;
  }

  constructor() {
    this.closePopup = new EventEmitter<void>();
  }

  ngOnInit(): void {
  }

  onClose(): void {
    this.closePopup.emit();
  }
}
